import { takeLatest, all, put, call } from "redux-saga/effects";
import * as calls from "./calls";
import * as reducerActions from "../../reducers/sessionReducer/actions";
import * as layoutActions from "../../reducers/layoutReducer/actions";
import * as Notifications from "../../components/Common/notification";

function* genGetInstalacion(e) {
  try {
    // llamo a la acción que busca la configuración de la instalación
    let instalacion = yield calls.getInstalacion(e.payload);

    // almaceno la configuración de la instalación en el reducer
    yield put(reducerActions.setInstalacion(instalacion));
  } catch (error) {
    if (error.Message) {
      return;
    }
  }
}

function* genGetUsuarioLogeado(e) {
  try {
    // llamo a la acción que busca el usuario autenticado
    let usuario = yield calls.getUsuarioLogeado(e.payload);

    if (usuario.idUsuario !== null) {
      // almaceno el usuario en el reductor
      yield put(reducerActions.setUsuario(usuario));

      // indico que el usuario está autenticado
      yield put(reducerActions.setResultadoAutenticacion({ autenticado: true }));
    }
  } catch (error) {
    yield put(
      reducerActions.setResultadoAutenticacion({
        error: error && (error.error || error.Message),
      })
    );
  } finally {
    // indico que se finalizó la búsqueda de usuario logeado
    yield put(layoutActions.setInicializandoUsuario(false));
  }
}

function* genAutenticarUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Verificando sus credenciales",
      })
    );

    // limpio el resultado de autenticación
    yield put(reducerActions.setDefaultResultadoAutenticacion());

    // llamo a la acción que autentica al usuario
    let resultadoAutenticacion = yield calls.autenticarUsuario(e.payload);
    // almaceno el resultado de la autenticación en el reducer
    yield put(
      reducerActions.setResultadoAutenticacion({
        error: resultadoAutenticacion.error || undefined,
        autenticado: resultadoAutenticacion.autenticado,
        restablecerContrasenia: false,
      })
    );

    // yield put(reducerActions.setFlagDatosAdicionales(false))

    // almaceno el usuario en el reductor
    yield put(reducerActions.setUsuario(resultadoAutenticacion.usuario));

    // llamo a la callback de usuario autenticado
    if (resultadoAutenticacion.autenticado === true) e.payload.onUsuarioAutenticado();
  } catch (e) {
    // muestro el mensaje de error
    yield put(reducerActions.setResultadoAutenticacion({ error: e.error }));
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genRestablecerContrasenia(e) {
  try {
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Restableciendo claves" }));

    // llamo a la acción que restablece la contraseña
    yield calls.restablecerContrasenia(e.payload);

    // indico que el usuario fue autenticado
    yield put(
      reducerActions.setResultadoAutenticacion({
        error: undefined,
        autenticado: false,
        restablecerContrasenia: false,
        token: undefined,
        usuarioId: undefined,
      })
    );

    // llamo a la función de callback
    e.payload.onContraseniaRestablecida();
  } catch (e) {
    // muestro el mensaje de error
    yield put(reducerActions.setResultadoAutenticacion({ error: e.error }));
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genOlvidoContrasenia(e) {
  try {
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true }));

    // llamo a la acción que ejecuta la lógica de olvido de contraseña
    yield calls.olvidoContrasenia(e.payload);

    // indico que se finalizó con el proceso de recuperación de contraseña
    yield put(
      reducerActions.setResultadoAutenticacion({
        claveProvisoriaGenerada: true,
      })
    );
  } catch (e) {
    // muestro el mensaje de error
    yield put(reducerActions.setResultadoAutenticacion({ error: e.error }));
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genValidarCodigo(e) {
  let payload = {};
  payload.callback = e.payload.callback;
  payload.callbackError = e.payload.callbackError;

  try {
    e.payload.callback = undefined;
    e.payload.callbackError = undefined;
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true }));

    // llamo a la acción que ejecuta la lógica de validación de codigo
    let response = yield calls.validarCodigo(e.payload);

    // indico que se finalizó con el proceso de recuperación de contraseña
    yield put(
      reducerActions.setResultadoAutenticacion({
        claveProvisoriaGenerada: true,
        usuarioId: response.usuarioId,
        token: response.token,
      })
    );

    if (payload.callback) {
      payload.callback();
    }
  } catch (e) {
    // muestro el mensaje de error
    yield put(reducerActions.setResultadoAutenticacion({ error: e }));
    if (payload.callbackError) {
      payload.callbackError(e);
    }
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genLogOutUsuario() {
  try {
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Cerrando Sessión" }));

    // llamo a la acción que ejecuta la lógica de cerrar la sesion
    yield calls.logOutUsuario();

    //armo objeto de autenticacion como default
    let resultadoAutenticacion = {
      error: undefined,
      autenticado: false,
      restablecerContrasenia: false,
      claveProvisoriaGenerada: false,
    };

    //  yield put(reducerActions.setFlagDatosAdicionales(false))

    //Seteo autenticacion como default
    yield put(reducerActions.setUsuario(undefined));

    //Seteo autenticacion como default
    yield put(reducerActions.setDefaultResultadoAutenticacion(resultadoAutenticacion));

    //Pongo usuario como undefined
    yield put(reducerActions.setUsuario(undefined));
  } catch {
    // muestro el mensaje de error
    //yield put(reducerActions.setResultadoAutenticacion({ error: e.error }))
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetImagenLogin(e) {
  try {
    // busco la imagen de login

    let imagen = yield calls.getImagenLogin(e.payload);

    //seteo las imagen de login
    yield put(reducerActions.setImagenLogin(imagen));
  } catch (error) {
    if (error.Message) {
      return;
    }
  }
}

function* genSetMontoCompraMinima(e) {
  try {
    // muestro el loader
    yield put(layoutActions.setLoading({ show: true, message: "Actualizando monto" }));

    // llamo a la acción que busca la configuración de la instalación
    let instalacion = yield calls.setMontoCompraMinima(e.payload);

    // almaceno la configuración de la instalación en el reducer
    yield put(reducerActions.setInstalacion(instalacion));
  } catch {
    // muestro el mensaje de error
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSetConfiguracionDelivery(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Actualizando configuracion de delivery",
      })
    );

    // llamo a la acción que busca la configuración de la instalación
    let instalacion = yield calls.setConfiguracionDelivery(e.payload);

    // almaceno la configuración de la instalación en el reducer
    yield put(reducerActions.setInstalacion(instalacion));
  } catch {
    // muestro el mensaje de error
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSetConfiguracionDeliveryBonificado(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Actualizando configuracion de delivery bonificado",
      })
    );

    // llamo a la acción que busca la configuración de la instalación
    let instalacion = yield calls.setConfiguracionDeliveryBonificado(e.payload);

    // almaceno la configuración de la instalación en el reducer
    yield put(reducerActions.setInstalacion(instalacion));
  } catch (e) {
    // muestro el mensaje de error
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genPutClaveSupervisorPicking(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Restableciendo claves supervisor",
      })
    );

    // // llamo a la acción que busca la clave
    let supervisorPicking = yield calls.setNuevaClavePicking(e.payload);

    // almaceno la nueva clave en el reductor
    yield put(reducerActions.saveNewClaveSupervisor(supervisorPicking));

    Notifications.showSuccess("Clave de supervisor reestablecida correctamente");
  } catch (e) {
    Notifications.showError("No se pudo cambiar la clave del supervisor");
    yield put({ type: "CLAVE_SUPERVISOR_PICKING_FAILED", message: e.message });
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }));
  }
}
function* genGetEstilosInterno() {
  try {
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Obteniendo estilos internos",
      })
    );

    const estilos = yield call(calls.getEstilosInterno);

    yield put(reducerActions.setEstilosInterno(estilos));
  } catch (e) {
    Notifications.showError("Error al obtener estilos internos");
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genGetEstilosOnline() {
  try {
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Obteniendo estilos online",
      })
    );
    const estilos = yield call(calls.getEstilosOnline);
    yield put(reducerActions.setEstilosOnline(estilos));
  } catch (e) {
    Notifications.showError("Error al obtener estilos online");
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSaveEstilosInterno(e) {
  try {
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Guardando estilos internos",
      })
    );
    yield call(calls.saveEstilosInterno, e.payload);
    yield put(reducerActions.setEstilosInterno(e.payload));
    Notifications.showSuccess("Estilos internos guardados");
  } catch (e) {
    Notifications.showError("Error al guardar estilos internos");
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* genSaveEstilosOnline(e) {
  try {
    yield put(
      layoutActions.setLoading({
        show: true,
        message: "Guardando estilos online",
      })
    );
    yield call(calls.saveEstilosOnline, e.payload);
    yield put(reducerActions.setEstilosOnline(e.payload));
    Notifications.showSuccess("Estilos online guardados");
  } catch (e) {
    Notifications.showError("Error al guardar estilos online");
  } finally {
    yield put(layoutActions.setLoading({ show: false }));
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_FETCH_INSTALACION, genGetInstalacion),
    takeLatest(reducerActions.SAGA_FETCH_USUARIO_LOGEADO, genGetUsuarioLogeado),
    takeLatest(reducerActions.SAGA_AUTENTICAR_USUARIO, genAutenticarUsuario),
    takeLatest(reducerActions.SAGA_RESTABLECER_CONTRASENIA, genRestablecerContrasenia),
    takeLatest(reducerActions.SAGA_OLVIDO_CONTRASENIA, genOlvidoContrasenia),
    takeLatest(reducerActions.SAGA_VALIDAR_CODIGO, genValidarCodigo),
    takeLatest(reducerActions.SAGA_LOGOUT_USUARIO, genLogOutUsuario),
    takeLatest(reducerActions.SAGA_FETCH_IMAGEN_LOGIN, genGetImagenLogin),
    takeLatest(reducerActions.SET_MONTO_COMPRAMINIMA, genSetMontoCompraMinima),
    takeLatest(reducerActions.SET_CONFIGURACION_DELIVERY, genSetConfiguracionDelivery),
    takeLatest(
      reducerActions.SET_CONFIGURACION_DELIVERY_BONIFICADO,
      genSetConfiguracionDeliveryBonificado
    ),
    // takeLatest(reducerActions.SAGA_CLAVE_SUPERVISOR_PICKING_OLD, genGetClaveSupervisorPicking),
    takeLatest(reducerActions.SET_CLAVE_SUPERVISOR_PICKING, genPutClaveSupervisorPicking),
    takeLatest(reducerActions.SAGA_GET_ESTILOS_INTERNO, genGetEstilosInterno),
    takeLatest(reducerActions.SAGA_GET_ESTILOS_ONLINE, genGetEstilosOnline),
    takeLatest(reducerActions.SAGA_SAVE_ESTILOS_INTERNO, genSaveEstilosInterno),
    takeLatest(reducerActions.SAGA_SAVE_ESTILOS_ONLINE, genSaveEstilosOnline),
  ]);
}

export const sagas = [defaultSaga];
